// QA
const GET_DDL_ITEMS = "ADMINRoutes/GetDDL"; 
const GET_MANAGERS = "AdminRoutes/getManagers"; 
const GET_ROLES = "AdminRoutes/getRoles"; 

export { 
    GET_DDL_ITEMS,
    GET_MANAGERS,
    GET_ROLES
};
  